import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { initialFilter } from "../config";

class MasterSopirFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: initialFilter,
      dataStatus: [
        { label: "Aktif", value: "ACTIVE" },
        { label: "Non Aktif", value: "INACTIVE" },
      ],
    };
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filter } = this.state;
    onSubmit(filter);
  };

  handleClear = () => {
    this.setState({
      filter: {
        driverUsername: null,
        driverName: null,
        driverCabang: null,
        driverStatus: null,
      },
    });
  };

  handleSetValue = ({ value, name }) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  componentDidMount() {
    const { submitedFilter } = this.props;
    if (this.props.submitedFilter) {
      this.setState({ filter: submitedFilter });
    }
  }

  render() {
    const { visible, onClickClose } = this.props;
    const { filter, dataStatus } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter Sopir"
          visible={visible}
          styles={{ width: "50%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView column style={{ gap: "15px" }}>
                <SimpleInput
                  name="driverUsername"
                  label="Username"
                  value={filter.driverUsername}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleInput
                  name="driverName"
                  label="Nama Sopir"
                  value={filter.driverName}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleInput
                  label="Cabang Bertugas"
                  name="driverCabang"
                  value={filter.driverCabang}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleDDL
                  label="AKTIF / NONAKTIF"
                  value={filter.driverStatus}
                  id="select_status"
                  box="search"
                  name="driverStatus"
                  options={dataStatus}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "driverStatus" })
                  }
                />
              </FlexView>
              <FlexView style={{ justifyContent: "flex-end" }}>
                <FlexView style={{ gap: "10px" }}>
                  <SimpleButton text="Hapus" onClick={this.handleClear} />
                  <SimpleButton text="Terapkan" onClick={this.handleSubmit} />
                </FlexView>
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterSopirFilter;
